module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/1_0-7da2c008b93a6d9526fc2d707084cacc.png";